import React from 'react'
import { 
  IonButton, 
  IonPopover, 
  IonList, 
  IonItem, 
  IonLabel,
  IonCheckbox
} from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { changeLanguage } from '../i18n'

interface LanguageSwitcherProps {
  className?: string
  size?: 'small' | 'default' | 'large'
  mobileOnly?: boolean
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ 
  className = '', 
  size = 'default',
  mobileOnly = false
}) => {
  const { i18n, t } = useTranslation()
  const [isOpen, setIsOpen] = React.useState(false)

  const languages = [
    { code: 'en', name: t('language.english'), flag: '🇬🇧' },
    { code: 'de', name: t('language.german'), flag: '🇩🇪' },
    { code: 'hu', name: t('language.hungarian'), flag: '🇭🇺' }
  ]

  const handleLanguageChange = (languageCode: string) => {
    changeLanguage(languageCode)
    setIsOpen(false)
  }

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0]

  return (
    <>
      <IonButton
        id="language-trigger"
        fill="clear"
        size={size}
        className={`language-switcher ${className}`}
        onClick={() => setIsOpen(true)}
      >
        <span className="text-2xl">{currentLanguage.flag}</span>
      </IonButton>

      <IonPopover
        trigger="language-trigger"
        isOpen={isOpen}
        onDidDismiss={() => setIsOpen(false)}
        showBackdrop={true}
      >
        <IonList>
          <IonItem lines="none" className="ion-padding-top">
            <IonLabel>
              <h3>{t('language.selectLanguage')}</h3>
            </IonLabel>
          </IonItem>
          {languages.map((language) => (
            <IonItem
              key={language.code}
              button
              onClick={() => handleLanguageChange(language.code)}
            >
              <div className="flex items-center space-x-3 w-full">
                <span className="text-2xl">{language.flag}</span>
                <div className="flex-1">
                  <IonLabel>
                    <div className="font-medium">
                      {language.name}
                    </div>
                  </IonLabel>
                </div>
                {i18n.language === language.code && (
                  <IonCheckbox 
                    checked={true} 
                    disabled={true}
                  />
                )}
              </div>
            </IonItem>
          ))}
        </IonList>
      </IonPopover>
    </>
  )
}

export default LanguageSwitcher 